import { useQuery } from "@apollo/client";
import { GET_SUPPLIER } from "../apollo/queries";
import { SESSION_STORAGE } from "../common/masterEnums";
import { decryptData } from "../utils/encryptData";
import { ROLES } from "../utils/encryptedConstants.";
import { getSelectedStoreDetails } from "../utils/helperFunctions";
import useFilters from "../core/hooks/useFilters";

const useSuppplier = () => {
  const { onChange, pagination, handlePageChange } = useFilters();
  const roles = decryptData(ROLES, SESSION_STORAGE);

  const { loading, data, refetch } = useQuery(GET_SUPPLIER, {
    variables: {
      input: {
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        role: roles?.map((item) => item?.name),
        full_name: null,
        email: null,
        phone: null,
        store_id: getSelectedStoreDetails("id"),
      },
    },
    fetchPolicy: "network-only",
  });

  return {
    values: {
      userList: data?.allUserByRole || [],
      total: data?.allUserByRole?.total || 0,
      loading,
      // search,
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.allUserByRole?.total || 0,
      },
    },
    functions: {
      onChange,
      refetch,
      handlePageChange,
    },
  };
};

export default useSuppplier;
